<template>
    <div class="w-100">
        <RatingModal
            :uid="$route.query.uid as string"
            :feedback-hash="$route.query.feedbackHash as string"
            :object-id="$route.query.objectId as string"
            :type="$route.query.type as string"
            :email-rating="parseInt($route.query.rating as string)"
        />
        <Banners v-if="!banners?.length && bannerList" :banners="bannerList.banner" :show-arrows="true" />

        <!--        <div class="container">-->
        <!--            <div class="productCarousel mt-0">-->
        <!--                <h1 class="h2 my-3 mt-3 mt-md-4">{{ bannersTitle ? bannersTitle : $t('carouselHomepage.defaultBannersTitle') }}</h1>-->
        <!--            </div>-->
        <!--        </div>-->

        <ElementsHomepageBanners
            :banners="upperBanners"
            :carousel-banners="upperCarouselBanners"
            matomo-banner-category="Homepage Banner"
        />

        <div class="container">
            <div class="productCarousel">
                <ElementsBannersTopCategory :banners="banners.slice(0, 3)" matomo-banner-category="Homepage Banner" :small="true" />
            </div>

            <div v-if="topicBanners?.length" class="productCarousel">
                <ElementsTopicBanners :banners="topicBanners.slice(0, 8)" />
            </div>

            <!--            <SkeletonProductCarouselSkeleton v-if="historyProductList === null" :max-number-of-products="6" />-->
            <!--            <div v-else-if="historyProductList.length > 0 && false" class="productCarousel">-->
            <!--                <CarouselBox-->
            <!--                    :title="$t('carouselHomepage.recentlyPurchasedProducts')"-->
            <!--                    :products="historyProductList"-->
            <!--                    class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    :item-list-name="recentlyPurchasedItemListName"-->
            <!--                />-->
            <!--            </div>-->

            <!--            <SkeletonProductCarouselSkeleton v-if="favoriteProducts === null" :max-number-of-products="6" />-->
            <!--            <div v-else-if="favoriteProducts.length > 0 && false" class="productCarousel">-->
            <!--                <CarouselBox-->
            <!--                    :title="$t('carouselHomepage.wishlistProducts')"-->
            <!--                    :products="favoriteProducts"-->
            <!--                    class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    :item-list-name="favoriteProductsItemListName"-->
            <!--                    :refresh-frequently-actualized-data="true"-->
            <!--                />-->
            <!--            </div>-->

            <!--            <DelayHydration>-->
            <!--                <ElementsProductTabs-->
            <!--                    :title="$t('carouselHomepage.title')"-->
            <!--                    :tabs="selectedProducts"-->
            <!--                    :item-list-name="pilulkaSelectsItemListName"-->
            <!--                    :lazy="false"-->
            <!--                    :show-pharmacy-price="false"-->
            <!--                    class="mt-4"-->
            <!--                />-->
            <!--            </DelayHydration>-->

            <DelayHydration>
                <ElementsCustomHomepageAddonSaleCarousels :carousels="customHomepageAddonSaleCarousels" />
            </DelayHydration>

            <BrandsBox :brands="brandLogos" />

            <SkeletonProductCarouselSkeleton v-if="lastBoughtRecommendedProducts === null" :max-number-of-products="6" />
            <div v-else-if="lastBoughtRecommendedProducts.length > 0" class="productCarousel">
                <CarouselBox
                    :title="$t('carouselHomepage.lastBoughtRecommendedProducts')"
                    :products="lastBoughtRecommendedProducts"
                    class="carouselBox--fullWidth"
                    :item-list-name="lastBoughtRecommendedProductsItemListName"
                    :refresh-frequently-actualized-data="true"
                />
            </div>

            <DailyOffer v-if="dailyDeal" :product="dailyDeal.product" :banner="{}" />

            <!--            <DelayHydration>-->
            <!--                <ElementsSalesAndDiscountsCarousel :products="actionsAndSalesProducts" />-->
            <!--            </DelayHydration>-->

            <!--            <DelayHydration>-->
            <!--                <div v-if="onePlusOneProducts?.length > 5" class="productCarousel">-->
            <!--                    <CarouselBox-->
            <!--                        :title="$t('carouselHomepage.onePlusOneProducts')"-->
            <!--                        :url="$t('header.url.category.onePlusOne')"-->
            <!--                        :products="onePlusOneProducts"-->
            <!--                        :item-list-name="onePlusOneProductsItemListName"-->
            <!--                        class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    />-->
            <!--                </div>-->
            <!--            </DelayHydration>-->

            <!--            <DelayHydration>-->
            <!--                <div v-if="twoPlusOneProducts?.length > 5" class="productCarousel">-->
            <!--                    <CarouselBox-->
            <!--                        :title="$t('carouselHomepage.twoPlusOneProducts')"-->
            <!--                        :url="$t('header.url.category.twoPlusOne')"-->
            <!--                        :products="twoPlusOneProducts"-->
            <!--                        :item-list-name="twoPlusOneProductsItemListName"-->
            <!--                        class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    />-->
            <!--                </div>-->
            <!--            </DelayHydration>-->

            <CarouselById
                v-if="isUserAuthenticated"
                :ids="lastViewProducts"
                :title="$t('carouselHomepage.lastViewProducts')"
                :class-carousel="'productCarousel--home'"
                :class-name="'carouselBox--fullWidth'"
                :available-only="true"
                :item-list-name="lastViewedProductsItemListName"
            />

            <!--            <ObjectsBenefitBoxes v-if="!isChristmasSeason" class="benefitBoxes&#45;&#45;top my-3" />-->
            <!--            <ObjectsChristmasUspBoxes v-else class="benefitBoxes&#45;&#45;top" />-->

            <MobileAppBanner />

            <!--            <HomepageStaticBanners :banner-list="servicesStaticBanners[locale] || []" />-->

            <ArticlesWidget :articles="articles" />

            <HomepageStaticBanners :banner-list="upperStaticBanners[locale] || []" />

            <HomepageStaticBanners :banner-list="lowerStaticBanners[locale] || []" />
        </div>

        <Head>
            <Title>{{ $t('homepageTitle') }}</Title>
            <Link v-if="preloadedBannerUrl" rel="preload" as="image" :href="preloadedBannerUrl" fetchpriority="high" />
            <Link rel="canonical" :href="$config.public.apiUrl" />
            <Meta name="description" :content="$t('metaDescription')" />
            <Body data-no-cache="true" />
            <!-- TODO Delete this after productCard test -->
        </Head>
    </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import DataLayer from '../extensions/DataLayer'
import RatingModal from '~/components/elements/RatingModal.vue'
import DailyOffer from '~/components/objects/DailyOffer.vue'
import Banners from '~/components/objects/Banners.vue'
import CarouselBox from '~/components/elements/CarouselBox.vue'
import BrandsBox from '~/components/layout/home/BrandsBox.vue'
import CarouselById from '~/components/elements/CarouselById.vue'
import { useCookie, useUidCookie } from '#imports'
import GtmPageData from '~/models/DataLayer/GtmPageData'
import useCommonStructuredData from '~/composables/useCommonStructuredData'
import { useBasketStore } from '~/stores/basket'
import useApiResponseCache from '~/composables/useApiResponseCache'
import PWAHomepage from '~/models/Api/PWAHomepage'
import { minimizeProductArray } from '~/utils/minimizeProductArray'
import HomepageStaticBanners from '~/components/layout/home/HomepageStaticBanners.vue'
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'
import MobileAppBanner from '~/components/layout/home/MobileAppBanner.vue'
import ArticlesWidget from '~/components/layout/home/ArticlesWidget.vue'
import { usePerformanceStore } from '~/stores/performace'
import { useAuthStore } from '~/stores/auth'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'
import { ResponseStatus } from '~/models/Api/ResponseStatus'
import hasCachedAsyncData from '~/composables/hasCachedAsyncData'
import GeneralResponse from '~/models/Api/GeneralResponse'

const nuxtApp = useNuxtApp()

const { data, error } = await useCachedAsyncData(
    'homepageAsyncData',
    300,
    async () => {
        const authStore = useAuthStore()
        const accessToken = authStore.accessToken
        const uid = useBasketStore().uid
        const homepagePromise = useApiResponseCache<PWAHomepage>(
            '/api/v2/pwa/homepage',
            600,
            async () => {
                const performanceStore = usePerformanceStore()
                const start = performance.now()
                const responseToReturn = [
                    'customHomepageAddonSaleCarousels',
                    'essentials',
                    'selectedProducts',
                    'saleProducts',
                    'dailyDeal',
                    'banners',
                    'upperBanners',
                    'upperCarouselBanners',
                    'topicBanners',
                ]
                responseToReturn.push('historyProductList', 'favoriteProducts')
                const generalResponse: GeneralResponse<PWAHomepage> = await nuxtApp.$repository.getPWAHomepageData({
                    accessToken,
                    response: responseToReturn,
                    uid,
                })

                if (!generalResponse.result && generalResponse.message.includes('Access token is invalid')) {
                    throw new Error('Access token is invalid')
                }

                const response = generalResponse.response

                performanceStore.add('api', performance.now() - start)

                try {
                    response.actionsAndSalesProducts = minimizeProductArray(response.actionsAndSalesProducts)
                } catch (e) {
                    console.log('actionsAndSalesProducts error', e)
                }

                try {
                    response.customHomepageAddonSaleCarousels = response.customHomepageAddonSaleCarousels.map((carousel) => {
                        carousel.products = minimizeProductArray(carousel.products)

                        return carousel
                    })
                } catch (e) {
                    console.log('customHomepageAddonSaleCarousels error', e)
                }

                try {
                    response.selectedProducts = response.selectedProducts.map((carousel) => {
                        carousel.products = minimizeProductArray(carousel.products)

                        return carousel
                    })
                } catch (e) {
                    console.log('selectedProducts error', e)
                }

                try {
                    response.favoriteProducts = minimizeProductArray(response.favoriteProducts)
                } catch (e) {
                    console.log('favoriteProducts error', e)
                }

                try {
                    response.historyProductList = {
                        products: response.historyProductList === null ? [] : minimizeProductArray(response.historyProductList.products),
                    }
                } catch (e) {
                    console.log('historyProductList error', e)
                }

                try {
                    response.onePlusOneProducts = minimizeProductArray(response.onePlusOneProducts)
                } catch (e) {
                    console.log('onePlusOneProducts error', e)
                }

                try {
                    response.twoPlusOneProducts = minimizeProductArray(response.twoPlusOneProducts)
                } catch (e) {
                    console.log('twoPlusOneProducts error', e)
                }

                return response
            },
            !accessToken // use cache only if accessToken is null or empty string
        )

        const lastBoughtRecommendedProductsPromise = accessToken
            ? nuxtApp.$repository.listLastBoughtRecommendedProducts({ accessToken, uid: useUidCookie().value || '' })
            : Promise.resolve({ response: { products: [] } })

        const [response, lastBoughtRecommendedProductsResponse] = await Promise.all([homepagePromise, lastBoughtRecommendedProductsPromise])

        return {
            dailyDeal: response.dailyDeal,
            selectedProducts: response.selectedProducts,
            brandLogos: response.brandLogos,
            customHomepageAddonSaleCarousels: response.customHomepageAddonSaleCarousels,
            bannerList: response.bannerList,
            structuredData: response.structuredData,
            actionsAndSalesProducts: response.actionsAndSalesProducts,
            articles: response.articles,
            favoriteProducts: response.favoriteProducts,
            historyProductList: response.historyProductList?.products || [],
            onePlusOneProducts: response.onePlusOneProducts,
            twoPlusOneProducts: response.twoPlusOneProducts,
            lastBoughtRecommendedProducts: lastBoughtRecommendedProductsResponse.response.products || [],
            banners: response.banners,
            upperBanners: response.upperBanners,
            upperCarouselBanners: response.upperCarouselBanners,
            bannersTitle: response.bannersTitle,
            topicBanners: response.topicBanners,
        }
    },
    { lazy: hasCachedAsyncData('homepageAsyncData') }
)

if (error.value?.message === 'Access token is invalid') {
    useAuthStore().logout()
    await safeNavigateTo('/')
} else if (!data.value) {
    throw createError({
        statusCode: ResponseStatus.INTERNAL_SERVER_ERROR,
        statusMessage: 'Internal server error. Invalid response from API',
    })
}

const customHomepageAddonSaleCarousels = ref(data.value?.customHomepageAddonSaleCarousels || [])
const lastBoughtRecommendedProducts = ref(data.value?.lastBoughtRecommendedProducts || [])
const bannerList = ref(data.value?.bannerList || [])
const dailyDeal = ref(data.value?.dailyDeal || null)
const articles = ref(data.value?.articles || [])
const brandLogos = ref(data.value?.brandLogos || [])
const banners = ref(data.value?.banners || [])
const upperBanners = ref(data.value?.upperBanners || [])
const upperCarouselBanners = ref(data.value?.upperCarouselBanners || [])
const upperStaticBanners = {
    sk: [],
    cs: [],
}
const lowerStaticBanners = {
    cs: [],
    sk: [],
}
const lastViewProducts = ref<number[]>([])
const topicBanners = ref(data.value?.topicBanners || [])

const initLuigisBoxEvents = () => {
    LuigisBoxEventApi.sendPageView()
}

const locale = computed((): 'cs' | 'sk' => {
    const i18n = useI18n()

    return i18n.t('locale') as 'cs' | 'sk'
})

const lastViewedProductsItemListName = computed((): string => {
    return GtmItemListNameEnum.HPLastVisited
})

const lastBoughtRecommendedProductsItemListName = computed((): string => {
    return GtmItemListNameEnum.HPLastBoughtRecommendedProducts
})

const preloadedBannerUrl = computed((): string | null => {
    if (bannerList.value && bannerList.value.banner && bannerList.value.banner.length) {
        return useDevice().isDesktop ? bannerList.value.banner[0].desktopImage : bannerList.value.banner[0].mobileImage
    }

    return null
})

const isUserAuthenticated = computed((): boolean => {
    return authUser.value !== null
})

const authUser = computed((): object | null => {
    const basketStore = useBasketStore()

    return basketStore.authUser
})

const config = useRuntimeConfig()

onMounted(() => {
    const page = {
        type: 'homepage',
        title: i18n.t('metaDescription'),
    } as GtmPageData

    DataLayer.pushPageViewToDataLayer(page)

    const idProducts = useCookie<number[]>('lastViewProductsIds').value
    lastViewProducts.value = idProducts && idProducts.length > 2 ? idProducts : []

    initLuigisBoxEvents()
})

const i18n = useI18n()

useJsonld(
    (() => {
        if (error.value) {
            return null
        }

        const commonStructuredData = useCommonStructuredData({
            config,
            i18nTranslate: i18n.t,
            breadcrumbsItems: [],
            addSearchAction: true,
        })

        const product = {
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@type': 'Product',
                    name: data.value.structuredData?.name,
                    aggregateRating: {
                        '@type': 'AggregateRating',
                        ratingValue: data.value.structuredData?.rating,
                        reviewCount: data.value.structuredData?.reviews,
                    },
                    offers: {
                        '@type': 'AggregateOffer',
                        lowPrice: data.value.structuredData?.aggregateOffer.minPrice,
                        priceCurrency: i18n.t('currency'),
                        highPrice: data.value.structuredData?.aggregateOffer.maxPrice,
                    },
                },
            ],
        }

        return [...commonStructuredData, product]
    })()
)
</script>

<style lang="scss" scoped>
h2 {
    font-size: 24px;
}
</style>
<style lang="scss" scoped>
.productCarousel {
    position: relative;
    max-width: $max-width-container-inside;
    margin: 1em auto 0em;
}
</style>
